<img ngSrc="/images/Icon-RAMASOFT-bleu.png" height="100" width="100" alt="icon-logo">
